<div class="cookie-consent">
  <div class="cookie-consent__msg">
    <b>Do you like cookies?</b> We use cookies to ensure you get the best
    experience on our website.
  </div>
  <div class="cookie-consent__actions">
    <app-button [buttonStyle]="BUTTON_STYLES.ACTION" (click)="allowCookies()"
      >Allow cookies</app-button
    >
    <app-button
      [buttonStyle]="BUTTON_STYLES.WHITE_OUTLINED"
      (click)="denyCookies()"
      >Cancel</app-button
    >
  </div>
</div>
